export const EditorPlaceholder = 'Reply';

export const TrophiesInputTooltip =
  'Boost this celebration by giving some of your :currency';
